import React, { useState } from "react";
import "../style.scss";
import DeleteDeactivateAcc from "../modals/DeleteDeactivateAcc";
import AccountManagementActions from "./AccountManagementActions";
import { useTranslation } from "../../../i18n/LanguageContext";

const AccountManagement = () => {
   const { t } = useTranslation();
   const [open, setOpen] = useState(false);
   const [action, setAction] = useState("");

   const actions = [
      {
         actionTitle: t("deactivate-account-title"),
         actionType: t("deactivate-account-description"),
         actionExplanation: t("deactivate-account-explanation"),
         actionButton: t("deactivate-account-title"),
         showModalType: "deactivate"
      },
      {
         actionTitle: t("delete-account-title"),
         actionType: t("delete-account-description"),
         actionExplanation: t("delete-account-explanation"),
         actionExplanation2: t("delete-account-explanation-2"),
         actionExplanation3: t("delete-account-explanation-3"),
         actionButton: t("delete-account-title"),
         showModalType: "delete"
      }
   ];

   const showModal = (type) => {
      setAction(type);
      setOpen(true);
   };

   const onClose = () => {
      setOpen(false);
   };

   const props = {
      open,
      onCancel: onClose,
      setOpen,
      title: action === "delete" ? t("delete-account-modal-title") : t("deactivate-account-modal-title"),
      description:
         action === "delete"
            ? t("delete-account-modal-description")
            : t("deactivate-account-modal-description"),
      buttonText: action === "delete" ? t("delete-account-title") : t("deactivate-account-title"),
      confirmationTitle:
         action === "delete" ? t("confirm-account-deletion-title") : t("confirm-account-deactivation-title")
   };

   return (
      <div className="accountManagementContainer">
         <div className="d-flex flex-column">
            <span className="title-heading">{t("account-management-title")}</span>
            {actions.map((actionItem, index) => (
               <div key={actionItem.showModalType}>
                  <AccountManagementActions {...actionItem} showModal={showModal} />
                  {index === 0 && (
                     <div style={{ padding: "40px 0" }}>
                        <span className="horizontal-line"></span>
                     </div>
                  )}
               </div>
            ))}
         </div>
         <DeleteDeactivateAcc {...props} action={action} />
      </div>
   );
};
export default AccountManagement;
